import { LitElement, html, svg } from 'lit';

export class IconBuilding32 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><title>Boligblokk</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M4 30V2h24v28"></path><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 30v-5a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v5M1.333 30.5h29.334M9 7h4M9 12h14M19 7h4M9 17h4M19 17h4"></path></svg>`; }
}
if (!customElements.get('f-icon-building32', IconBuilding32)) {
  customElements.define('f-icon-building32', IconBuilding32);
}